import { formatTime } from './formatTime';

export function timeSecondsToString(time: number) {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return formatTime(minutes + ':' + seconds);
}
